export const PLAYOUT_KEYS = [
    "adId",
    "advertiserId",
    "advertiserName",
    "artistName",
    "bonus",
    "duration",
    "eventId",
    "status",
    "text",
    "type",
    "grossRate",
    "market",
    "startDate",
    "startTime",
    "startDateTime",
    "stationName",
    "stationBand",
    "stationCallLetters",
    "stationCity"
];

export const WEB_KEYS = [
    'date',
    'hour',
    'minute',
    'visits',
    'newUsers',
    'trafficChannel',
    'location'
]
export const JOB_PREFIX = 'job_';
export const TDO_PREFIX = 'TDO_Id_';
export const JOB_ROUTES = [];
export const PLAYOUT_DATA_TYPE = 1;
export const WEB_DATA_TYPE = 2;

//advertiser connection description
export const CONNECT_DESCRIPTIONS_BY_GA = {
    SUCCESS: 'Connected',
    PENDING: 'Invite Pending',
    DISCONNECTED: 'Disconnected',
    NO_RECENT_DATA: 'No Recent Website Analytics'
};

export const CONNECT_DESCRIPTIONS_BY_WEB_UPLOAD = {
    SUCCESS: 'Website Analytics Available',
    NO_RECENT_DATA: 'No Recent Website Analytics',
    NO_DATA: 'No Website Analytics'
};
